import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import ClassificacaoForm from '../ClassificacaoForm/ClassificacaoForm';

interface ClassificacaoModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialValues?: any;
}

const ClassificacaoModal: React.FC<ClassificacaoModalProps> = ({ isOpen, onClose, initialValues }) => {
  const isEditing = initialValues.id !== null;
  const title = isEditing ? 'Editar Classificação' : 'Adicionar Classificação';

  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose} heading={title}>
          <ClassificacaoForm initialValues={initialValues} onSubmit={onClose} onClose={onClose} />
        </Modal>
      )}
    </ModalTransition>
  );
};

export default ClassificacaoModal;
